// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    mat-dialog-content {
      max-height: 70vh;
      overflow-y: auto;
      padding: 20px 24px;
    }
    h4 {
      color: #369;
      margin-bottom: 15px;
      font-weight: 600;
    }
    ::ng-deep .mat-checkbox-label {
      white-space: normal !important;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/test-assignment-detail/pdf-options-dialog.component.ts"],"names":[],"mappings":";IACI;MACE,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;IACpB;IACA;MACE,WAAW;MACX,mBAAmB;MACnB,gBAAgB;IAClB;IACA;MACE,8BAA8B;IAChC","sourcesContent":["\n    mat-dialog-content {\n      max-height: 70vh;\n      overflow-y: auto;\n      padding: 20px 24px;\n    }\n    h4 {\n      color: #369;\n      margin-bottom: 15px;\n      font-weight: 600;\n    }\n    ::ng-deep .mat-checkbox-label {\n      white-space: normal !important;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
